<template>
  <dialog-modal :show="isShow">
    <template #title>
      <div class="flex font-bold justify-center">
        パスワードリセット
      </div>
    </template>
    <template #content>
      <div class="mx-auto flex justify-center">
        <div class="mx-auto">
          <!-- <div class="mb-5">パスワード再設定</div> -->
          <form @submit.prevent="resetPassword">
            <label for="email">
              メールアドレス
            </label>
            <input
              v-model="email"
              class="block mt-2 mb-2 w-80 border-1 border-gray-500 rounded"
              type="email"
              required
              placeholder="メールアドレス"
              autocomplete="email" />
            <div
              v-if="resetPasswordFormErrorText"
              class="text-red-500 mb-5">
              ※{{ resetPasswordFormErrorText }}
            </div>
            <button
              :disabled="isProcessing"
              class=" flex justify-self-end text-white text-center text-base bg-CLIENT_PRIMARY_PINK rounded-xl
                  mx-auto mt-2 px-10 py-2 hover:bg-CLIENT_PRIMARY_PINK_HOVER duration-500 disabled:bg-gray-300
                  disabled:cursor-not-allowed">
              再設定用メールを送信
            </button>
          </form>
        </div>
      </div>
    </template>

    <template #footer>
      <button
        class="text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 ml-4 bg-white hover:bg-gray-100 duration-500"
        @click.prevent="$emit('close')">
        閉じる
      </button>
    </template>
  </dialog-modal>
</template>

<script setup>
import { ref } from 'vue'
import Swal from 'sweetalert2'
import {
  getAuth,
  sendPasswordResetEmail,
} from 'firebase/auth'
import DialogModal from '@/Common/DialogModal'
import firebaseApp from '@/Constants/configFirebase'
import 'firebase/compat/auth'
import { EmailRegex } from '@/Constants/regularExpression'

const props = defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close'])

const auth = getAuth(firebaseApp)
const email = ref('')
const resetPasswordFormErrorText = ref('')
const isProcessing = ref(false)

const actionCodeSettings = {
  url: route('clients.login.index'),
}

const resetPassword = () => {
  if (!email.value.match(EmailRegex)) {
    resetPasswordFormErrorText.value = '登録されているメールアドレスを正しく入力してください。'
    return false
  }
  resetPasswordFormErrorText.value = ''

  // 多重ポストを避ける
  if (isProcessing.value) return false
  isProcessing.value = true

  sendPasswordResetEmail(auth, email.value, actionCodeSettings).then(() => {
    isProcessing.value = false
    emit('close')
    Swal.fire({
      html: 'パスワード再設定用のメールを送信しました。',
      icon: 'success',
      confirmButtonText: '閉じる',
    })
  }).catch((e) => {
    // eslint-disable-next-line no-alert
    alert(e)
    isProcessing.value = false
    emit('close')
    return false
  })
  return undefined
}

</script>
